import { render, staticRenderFns } from "./AddEditRemoteConnectionTunnel.vue?vue&type=template&id=10bdcbc3"
import script from "./AddEditRemoteConnectionTunnel.vue?vue&type=script&lang=js"
export * from "./AddEditRemoteConnectionTunnel.vue?vue&type=script&lang=js"
import style0 from "./AddEditRemoteConnectionTunnel.vue?vue&type=style&index=0&id=10bdcbc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports